import * as Sentry from "@sentry/browser";
import "./nodelist-foreach-polyfill";

(async () => {
    if (!self.fetch) {
        await import(/* webpackChunkName: "fetch-polyfill" */ "whatwg-fetch");
        Sentry.setExtra("fetch polyfill loaded", Sentry.Severity.Info);
    }
})();
